import { createRoute, redirect, useLoaderData } from "@tanstack/react-router";
import type { QueryClient } from "@tanstack/react-query";
import { unwrapPageInitialData, type PageInitialData } from "~/app/api/pageData";
import { quoteConfirmationPageQueryOptions } from "~/app/api/pageData/quoteConfirmationPageQuery";
import type { QuoteConfirmationPageInitialData } from "~/app/api/pageData/quoteConfirmationPageInitialData";
import { StorefrontShellFrame } from "~/app/shell/StorefrontShellFrame";
import { useStorefrontShellProps } from "~/app/router/storefrontShellPropsContext";
import { rootRoute } from "~/app/router/rootRoute";
import { createQuoteConfirmationPage } from "~/features/cart/cart/jspComponents/QuoteConfirmationPageComponent";

function QuoteConfirmationRoute() {
  const result = useLoaderData({
    from: "/quote/confirm/$orderCode",
  }) as PageInitialData<QuoteConfirmationPageInitialData>;
  const shellProps = useStorefrontShellProps();

  return (
    <StorefrontShellFrame variant={shellProps.variant} metadata={result.metadata}>
      {createQuoteConfirmationPage()}
    </StorefrontShellFrame>
  );
}

export async function loadQuoteConfirmationPageData(context: { queryClient: QueryClient }, orderCode: string) {
  const result = await context.queryClient.ensureQueryData(quoteConfirmationPageQueryOptions(orderCode));

  return unwrapPageInitialData(result);
}

export const quoteConfirmationRedirectRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/quote/confirm",
  loader: () => {
    throw redirect({ href: "/quote" });
  },
});

export const quoteConfirmationRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/quote/confirm/$orderCode",
  loader: async ({ context, params }) => loadQuoteConfirmationPageData(context, params.orderCode),
  component: QuoteConfirmationRoute,
});
